import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: 'appTouchable'
})
export class TouchableDirective {

    private touching: boolean;

    @HostListener('touchstart')
    start () {
        this.touching = true;
    }

    @HostListener('touchend')
    @HostListener('touchmove')
    end () {
        this.touching = false;
    }

    @HostBinding('class.TOUCHING') get status () {
        return this.touching;
    }

}
